import React, { useMemo } from 'react';
import Modal from './Modal';
import Button from './Button';
import { PayrollSettings } from '../../shared/types.js';
import { calculatePeriodDates } from '../utils.js';
import { LockIcon } from './icons';

interface Props {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    payrollSettings: PayrollSettings;
}

const ClosePeriodModal: React.FC<Props> = ({ isOpen, onClose, onConfirm, payrollSettings }) => {
    const { end: currentPeriodEnd } = useMemo(() => calculatePeriodDates(payrollSettings), [payrollSettings]);
    
    const nextPeriodStart = useMemo(() => {
        const nextDay = new Date(currentPeriodEnd.getTime());
        nextDay.setDate(currentPeriodEnd.getDate() + 1);
        return nextDay;
    }, [currentPeriodEnd]);

    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Close Payroll Period">
            <div className="text-center text-gray-900 dark:text-white">
                <LockIcon className="w-16 h-16 text-red-500 mx-auto mb-4" />
                <h3 className="text-2xl font-bold mb-2">Are you sure?</h3>
                <p className="text-gray-600 dark:text-gray-300">
                    You are about to close the current payroll period ending on:
                </p>
                <p className="font-bold text-lg my-2">{currentPeriodEnd.toLocaleDateString()}</p>
                <p className="text-gray-600 dark:text-gray-300">
                    The new period will start on:
                </p>
                <p className="font-bold text-lg my-2">{nextPeriodStart.toLocaleDateString()}</p>
                <p className="mt-4 p-3 bg-yellow-100 dark:bg-yellow-900/50 text-yellow-800 dark:text-yellow-300 rounded-md">
                    <strong>Warning:</strong> All time entries before {nextPeriodStart.toLocaleDateString()} will become read-only.
                </p>
                 <div className="flex justify-center gap-4 mt-8">
                    <Button variant="secondary" onClick={onClose}>Cancel</Button>
                    <Button variant="danger" onClick={onConfirm}>Close Period</Button>
                </div>
            </div>
        </Modal>
    );
};
export default ClosePeriodModal;